import React, { useMemo } from 'react';
import { useCart } from '../context/CartContext';
import { useMerchant } from '../context/MerchantContext';
import { getCartSuggestions, getProductTag } from '../services/SuggestionService';
import SuggestedProductCard from './SuggestedProductCard';

const CartSuggestions: React.FC = () => {
  const { state } = useCart();
  const { restaurant, merchantId, menuCategories } = useMerchant();

  const suggestedProducts = useMemo(() => {
    // Priority 1: Use full menuCategories if available (synced from MenuPage)
    // Priority 2: Fallback to restaurant.categories (might be incomplete)
    const categories = menuCategories.length > 0 
      ? menuCategories 
      : (restaurant?.categories || (restaurant as any)?.restaurantCategories);
    
    if (!categories || !merchantId) return [];
    return getCartSuggestions(state.items, categories, merchantId, 6);
  }, [state.items, restaurant, merchantId, menuCategories]);

  if (suggestedProducts.length === 0) return null;

  const getTag = (product: any) => {
    const category = restaurant?.categories?.find(c => c.id === product.categoryId);
    return getProductTag(product, category?.name || '');
  };

  return (
    <div className="mt-2 mb-4">
      <h5 className="h6 fw-bold text-dark mb-3 px-1">Que tal adicionar?</h5>
      <div 
        className="d-flex gap-3 overflow-auto pb-2 px-1" 
        style={{ 
          scrollbarWidth: 'none', 
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch'
        }}
      >
        {suggestedProducts.map((product) => (
          <div key={product.id} className="flex-shrink-0" style={{ width: '150px' }}>
            <SuggestedProductCard 
              item={product} 
              tag={getTag(product)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CartSuggestions;
